// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__2WcZz","error":"styles_error__20UAP"};